import axios from 'axios'

import type {
  Participant as ParticipantType,
  FetchParticipantsResponse,
} from 'types/Participants'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import getToken from 'lib/authentication/GetToken'
import { getBaseURL, createQueryString } from 'lib/utility/GetBaseUrl'
import getCamelCaseKeys from 'lib/utility/GetCamelCaseKeys'
import AxiosInitializer from 'api/Utility/AxiosInitializer'

let abortController: AbortController | null = null

export const fetchParticipant = async (id: string) => {
  try {
    const axios = AxiosInitializer({ token: getToken() })
    const response = await axios.get(`site_users/${id}`)

    if (!response.data.included) {
      return {
        ...response.data.data,
      }
    }
    return {
      ...response.data.data,
      signupFormResponse: response.data.included[0],
    }
  } catch (error: any) {
    if (error.code == 'ERR_BAD_REQUEST') {
      const response = {
        status: error.response.status,
      }

      return response
    }
    return handleStatus500(error)
  }
}

export const fetchParticipants = async (query: any) => {
  if (abortController) {
    abortController.abort()
  }

  abortController = new AbortController()

  // this is a temporary fix , proper type def will be applied later
  const axiosConfig: any = {
    headers: {
      'x-api-token': `Bearer ${getToken()}`,
    },
    signal: abortController.signal,
  }

  try {
    const url = `${getBaseURL()}/api/v2/site_users?${createQueryString(query)}`
    const response = await axios.get(url, axiosConfig)
    const { data = {}, meta = { count: 0 } } = response.data
    let participants: ParticipantType[] = data.map((participant: any) => ({
      id: participant.id,
      ...participant.attributes,
    }))
    participants = participants.map((participant) =>
      getCamelCaseKeys(participant),
    )
    return {
      participants,
      meta,
    } as FetchParticipantsResponse
  } catch (error: any) {
    return handleStatus500(error)
  }
}
